module.exports = __webpack_public_path__ + "static/img/beijing-bg.526fbdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/beijing-bg.jpg
// module id = jnn0
// module chunks = 1